import styles from './styles.module.css'
import React from 'react'
import LoadingText from '@components/LoadingText'

export default function MobileSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.buttons}>
        <div className={styles.square}>
          <LoadingText color="#eaeaea" lineHeight={80} />
        </div>
        <div className={styles.square}>
          <LoadingText color="#eaeaea" lineHeight={80} />
        </div>
        <div className={styles.square}>
          <LoadingText color="#eaeaea" lineHeight={80} />
        </div>
      </div>
      <LoadingText color="#eaeaea" lineHeight={40} />
    </div>
  )
}
